import { CSSProperties } from 'react'

import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: { md: 'center' },
  justifyContent: { md: 'center', lg: 'initial' },
  minHeight: 'auto',
  padding: {
    xs: '2.4rem',
    md: '2.4rem 5.6rem',
    lg: '0 12.6rem',
  },
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const formContainerSx: SxProps<Theme> = {
  width: {
    xs: '100%',
    lg: '46.8rem',
    xl: '70.8rem',
  },
  gap: { xs: '1.6rem', md: '2.4rem' },
  marginRight: { lg: 'auto' },
}

export const firstAndLastNameContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: { xs: '1.6rem', md: '2.4rem', lg: '2rem' },
  marginTop: {
    xs: '0.8rem',
    md: 0,
    lg: '1.6rem',
  },
}

export const emailAndPhoneContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: { xs: '1.6rem', md: '2.4rem', lg: '2rem' },
}

export const messageSx: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    minHeight: '6.8rem !important',
  },
  '& .MuiInputLabel-formControl:not([data-shrink=true])': {
    transform: 'translate(14px, 2.3rem) scale(1);',
  },
}

export const submitButtonIconSx: SxProps<Theme> = {
  width: '2.4rem',
  height: '2.4rem',
}

export const loadingButtonSx: SxProps<Theme> = {
  lineHeight: '1.6rem',
  alignSelf: { xs: 'stretch', md: 'flex-start' },
}

export const radioLabelSx: SxProps<Theme> = {
  fontWeight: 500,
}

export const radioSectionTitle: SxProps<Theme> = {
  lineHeight: '2rem',
  letterSpacing: '0.015rem',
  fontWeight: 500,
}

export const contactUsSx: SxProps<Theme> = {
  fontWeight: {
    xs: 500,
    md: 700,
  },
  lineHeight: {
    xs: '3.2rem',
    md: '5.7rem',
  },
  fontSize: {
    xs: '2.4rem',
    md: '4.8rem',
  },
  letterSpacing: {
    xs: 0,
    md: '0.096rem',
  },
}

export const radioSectionSx: SxProps<Theme> = {
  gap: '1.2rem',
}

export const radioGroupSx: SxProps<Theme> = {
  display: 'flex',
  gap: {
    xs: '0.8rem',
    md: '1.6rem',
  },
}

export const inputStyle: CSSProperties = {
  letterSpacing: '0.015rem',
}
